import { Tab } from '../../../../../views/customer-base';
import { BillingTypeOptions } from '../../../../../views/customer-base/BillingHealthTab';
import { BillingMode } from '../../../../../services/exports/Constants';

export default {
  tabs: {
    [Tab.Performance]: 'Wyniki',
    [Tab.NewCustomers]: 'Nowe restauracje',
    [Tab.CustomerHealth]: 'Kondycja klientów',
    [Tab.LiveAndInactive]: 'Aktywne i nieaktywne',
    [Tab.BillingHealth]: 'Kondycja rozliczeń',
  },
  labels: {
    sales_manager: 'Menedżer sprzedaży',
  },
  performance_tab: {
    table_columns: {
      name: 'Nazwa',
      sales_manager: 'Menedżer sprzedaży',
      orders: 'Zamówienia',
      sales: 'Sprzedaż',
      previous_month_sales: 'Przychód z poprzedniego miesiąca',
    },
    labels: {
      sales_volume: 'Wolumen sprzedaży:',
      all: 'Wszystkie',
      click_to_sort: 'Kliknij, aby sortować',
      no_data: 'Brak danych',
    },
    toasts: {
      failed_to_load_data: 'Nie udało się wczytać danych',
    },
  },

  new_restaurants_tab: {
    table_columns: {
      name: 'Nazwa',
      sales_manager: 'Menedżer sprzedaży',
      orders: 'Zamówienia',
      sales: 'Sprzedaż',
      days_live: 'Dni aktywności',
      early_performance: 'Wczesne wyniki',
    },
    labels: {
      click_to_sort: 'Kliknij, aby sortować',
      no_data: 'Brak danych',
      only_with_early_performance: 'Tylko z wczesnymi wynikami: ',
      early_performance_yes: '✔️ Tak',
      early_performance_no: '✗ Nie',
    },
    toasts: {
      failed_to_load_data: 'Nie udało się wczytać danych',
    },
  },

  customer_health_tab: {
    titles: {
      sales_tiers: 'Poziomy sprzedaży',
      payments_ratio: 'Wskaźnik płatności',
    },
    dataset_labels: {
      negative: 'Ujemny ({{values}})',
      ok: 'OK ({{values}})',
      good: 'Dobry ({{values}})',
      excellent: 'Doskonały ({{values}})',
    },

    companies_preview_modal: {
      title: 'Podgląd restauracji',
      table_columns: {
        name: 'Nazwa',
        sales_manager: 'Menedżer sprzedaży',
        orders: 'Zamówienia',
        sales: 'Sprzedaż',
        total_payments: 'Łączne płatności',
        payments_ratio: 'Wskaźnik płatności',
      },
      labels: {
        close: 'Zamknij',
        click_to_sort: 'Kliknij, aby sortować',
        no_data: 'Brak danych',
      },
    },
    toasts: {
      failed_to_load_data: 'Nie udało się wczytać danych',
    },
  },

  live_and_inactive_tab: {
    dataset_labels: {
      live: 'Aktywne',
      no_orders: 'Brak zamówień',
      no_conversion: 'Brak konwersji',
    },
    toasts: {
      failed_to_load_data: 'Nie udało się wczytać danych',
    },
  },

  billing_health_tab: {
    filters: {
      billing_type: {
        label: 'Typ rozliczenia',
        options: {
          [BillingTypeOptions.Subscription]: 'Subskrypcja',
          [BillingTypeOptions.Manual]: 'Inne',
        },
      },
      high_risk_only: {
        label: 'Tylko klienci wysokiego ryzyka',
      },
    },
    fields: {
      name: 'Nazwa',
      live_from: 'Aktywny od',
      billing_mode: {
        title: 'Źródło rozliczenia',
        options: {
          [BillingMode.Stripe]: 'Metoda płatności',
          [BillingMode.InternalInvoicing]: 'Sprzedaż',
        },
      },
      trial_ends_at: 'Koniec trialu',
      last_failed_invoice_amount: 'Kwota ostatniej nieudanej faktury',
      failed_payments_count: 'Liczba nieudanych płatności',
    },
    tags: {
      is_high_billing_risk_customer: 'Wysokie ryzyko rozliczeń',
    },
    toasts: {
      failed_to_load_data: 'Nie udało się wczytać danych',
    },
  },
};
